<script setup lang="ts">
import { computed, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    password?: string | null
    showErrors?: boolean
  }>(),
  { showErrors: false },
)

const emit = defineEmits<{
  'update:valid': [value: boolean]
}>()

const pw = computed(() => props.password ?? '')
const passed = computed(() => pw.value.length >= 8 && pw.value.length <= 64)

watch(passed, (val) => emit('update:valid', val), { immediate: true })
</script>

<template>
  <p class="mt-1.5 text-xs" :class="passed ? 'text-green-600' : showErrors ? 'text-red-500' : 'text-gray-500'">
    Must be between 8 and 64 characters
  </p>
</template>
